// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9fef147d","982":"ad019e57"}[chunkId] + ".chunk.js";
};